module.exports = __webpack_public_path__ + "static/media/searchIcon.d1149fa3.svg";